export default __webpack_public_path__ + "images/a1aaa84489caaf0f41792a5b1de19070-ironing.svg";